import React from 'react';
import PostCardSkeleton from './PostCardSkeleton';

const PostsSkeleton = ({ loading = true }) => {
  return (
    <>
      {loading ? (
        <div className='my-4 flex flex-wrap gap-4 '>
          <PostCardSkeleton />
          <PostCardSkeleton noImage={true} />
          <PostCardSkeleton />
          <PostCardSkeleton />
          <PostCardSkeleton noImage={true} />
          <PostCardSkeleton />
        </div>
      ) : null}
    </>
  );
};

export default PostsSkeleton;
